import { css, Theme } from '@mui/material';

export const globalStyles = (theme: Theme) => {
  return css`
    body {
      overflow-x: hidden;
      background-color: ${theme.colors.bodyColor};
      color: ${theme.colors.defaultTextColorAuth};
      ${theme.breakpoints.down('lg')} {
        background-color: ${theme.palette.grey[700]};
      }
    }
  `;
};
